import { ModalOverlay, ModalContent, CloseButton } from "./style";

export const UnsubscribedModal = ({setIsOpenModal}) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const handleClose = () => {
    setIsOpenModal(false);
  };

  return (
    <ModalOverlay onClick={handleOverlayClick}>
      <ModalContent>
        <CloseButton onClick={handleClose}>X</CloseButton>
        <div>
          <p>Es necesario suscribirse</p>
          <a href="/suscripciones/landing.html">Suscribirme</a>
        </div>
      </ModalContent>
    </ModalOverlay>
  );
};